import { Tooltip } from "primereact/tooltip";
import { useTranslation } from "react-i18next";

export default function KH1000140009() {
  const { i18n } = useTranslation();

  if (i18n.language === "en") {
    return (
      <>
        <p>
          1. Paul Lim Pay Chuan
          <span className="vertical-align-super b text-xs text-yellow-500 pl-1">
            (b)
          </span>
          <Tooltip target=".b" position="right" event="both">
            Executive Chairman
          </Tooltip>
        </p>
        <p>
          2. Lim Ah Hock
          <span className="vertical-align-super c text-xs text-yellow-500 pl-1">
            (c)
          </span>
          <Tooltip target=".c" position="right" event="both">
            Executive Director
          </Tooltip>
        </p>
        <p>
          3. Han Fatt Juan
          <span className="vertical-align-super d text-xs text-yellow-500 pl-1">
            (d)
          </span>
          <Tooltip target=".d" position="right" event="both">
            Executive Director/CEO
          </Tooltip>
        </p>
        <p>
          4. Charles Tan Pu Hooi
          <span className="vertical-align-super e text-xs text-yellow-500 pl-1">
            (e)
          </span>
          <Tooltip target=".e" position="right" event="both">
            Executive Director
          </Tooltip>
        </p>
        <p>
          5. Dav Ansan
          <span className="vertical-align-super f text-xs text-yellow-500 pl-1">
            (f)
          </span>
          <Tooltip target=".f" position="right" event="both">
            Independent Non-Executive Director
          </Tooltip>
        </p>
      </>
    );
  }
  return (
    <>
      <p>
        ១. លោក Paul Lim Pay Chuan
        <span className="vertical-align-super b text-xs text-yellow-500 pl-1">
          (b)
        </span>
        <Tooltip target=".b" position="right" event="both">
          ប្រធានក្រុមប្រឹក្សាភិបាល
        </Tooltip>
      </p>
      <p>
        ២. លោក Lim Ah Hock
        <span className="vertical-align-super c text-xs text-yellow-500 pl-1">
          (c)
        </span>
        <Tooltip target=".c" position="right" event="both">
          អភិបាលប្រតិបត្តិ
        </Tooltip>
      </p>
      <p>
        ៣. លោក Han Fatt Juan
        <span className="vertical-align-super d text-xs text-yellow-500 pl-1">
          (d)
        </span>
        <Tooltip target=".d" position="right" event="both">
          អភិបាលប្រតិបត្តិ/នាយកប្រតិបត្តិ
        </Tooltip>
      </p>
      <p>
        ៤. លោក Charles Tan Pu Hooi
        <span className="vertical-align-super e text-xs text-yellow-500 pl-1">
          (e)
        </span>
        <Tooltip target=".e" position="right" event="both">
          អភិបាលប្រតិបត្តិ
        </Tooltip>
      </p>
      <p>
        ៥. លោក ដាវ អានសាន
        <span className="vertical-align-super f text-xs text-yellow-500 pl-1">
          (f)
        </span>
        <Tooltip target=".f" position="right" event="both">
          អភិបាលឯករាជ្យ
        </Tooltip>
      </p>
    </>
  );
}
